import { getURLParameter } from "../../../../../shared/lib/html5-software-library/src/ranj/util/URLUtil";
import Config from "../../../../../shared/src/ranj/app/config/Config";
import AppModel from "../../../../../shared/src/ranj/app/core/AppModel";
import PuzzleRandomizer from "../util/PuzzleRandomizer";

export default class GameConfig extends Config {
    /**
     * @constructor
     * @param {AppModel} appModel 
     */
    constructor(appModel) {
        super();

        this._appModel = appModel;
    }

    setPropertiesFromObject(obj) {
        super.setPropertiesFromObject(obj);

        if (getURLParameter("randomization") === "0") {
            this._puzzles = this.getValue("puzzles");
            this._practicePuzzles = this.getValue("practicePuzzles");
        } else {
            this._puzzles = PuzzleRandomizer.generatePuzzle(
                this.getValue("randomizedPuzzles"),
                this.getValue("availablePuzzleLocations")
            );
            this._practicePuzzles = PuzzleRandomizer.generatePuzzle(
                this.getValue("randomizedPracticePuzzles"),
                this.getValue("availablePracticePuzzleLocations")
            );
            var index = 0;
        }
    }

    get puzzles() {
        return this._puzzles;
    }
    
    get practicePuzzles() {
        return this._practicePuzzles;
    }

    getPracticePuzzle(idx, wrap = true) {
        if (wrap) {
            idx = idx % this.practicePuzzles.length
        }
        return this.practicePuzzles[idx];
    }

    getPuzzle(idx, wrap = true) {
        if (wrap) {
            idx = idx % this.puzzles.length
        }
        return this.puzzles[idx];
    }

    getLocation(index) {
        return this.getValue(`locations`)[index];
    }

    getLocationSkin(index) {
        return this.getLocation(index).skin;
    }

    getItemName(index) {
        return this.getValue(`items`)[index];
    }

}